import {Component, OnInit} from '@angular/core';
import {PresentsHttpService} from '../../../../services/http-services/presents/presents-http.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {PresentStateService} from "../../../../services/helpers/present-state.service";

@Component({
  selector: 'app-single-present',
  templateUrl: './single-present.component.html',
})
export class SinglePresentComponent implements OnInit {
  present: any;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(
    private presentsHttpService: PresentsHttpService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private presentStateService: PresentStateService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.presentsHttpService.getSinglePresent({presentId: res.id}).then(presentRes => {
          this.present = presentRes.data;
        });
      }
    });
  }

  goBack(): void {
    const listState = this.presentStateService.getListState();
    if (listState) {
      this.router.navigate(['/presents'], { queryParams: listState });
    } else {
      this.router.navigate(['/presents']);
    }
  }

}
